import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { bindNativePush, unbindNativePush } from '@/lib/nativePush';

export default function NativeMobileSession() {
  const { user } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (user?.id && !user.must_change_password) {
      bindNativePush(user, (route) => navigate(route)).catch(() => {});
    }
    return unbindNativePush;
  }, [user?.id, user?.role, user?.must_change_password, navigate]);
  return null;
}
